var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2531 4.90156C12.6615 4.90156 13.8031 3.82705 13.8031 2.50156C13.8031 1.17608 12.6615 0.101562 11.2531 0.101562C9.8448 0.101562 8.70312 1.17608 8.70312 2.50156C8.70312 2.60195 8.70967 2.7009 8.72239 2.79805L4.52333 4.77408C4.0647 4.35768 3.44069 4.10156 2.75313 4.10156C1.3448 4.10156 0.203125 5.17608 0.203125 6.50156C0.203125 7.82705 1.3448 8.90156 2.75313 8.90156C3.44071 8.90156 4.06473 8.64543 4.52336 8.22902L8.7224 10.205C8.70968 10.3022 8.70312 10.4012 8.70312 10.5016C8.70312 11.827 9.8448 12.9016 11.2531 12.9016C12.6615 12.9016 13.8031 11.827 13.8031 10.5016C13.8031 9.17608 12.6615 8.10156 11.2531 8.10156C10.5656 8.10156 9.94155 8.35768 9.48292 8.77408L5.28386 6.79805C5.29658 6.7009 5.30313 6.60195 5.30313 6.50156C5.30313 6.40116 5.29657 6.3022 5.28385 6.20504L9.48289 4.22902C9.94152 4.64543 10.5655 4.90156 11.2531 4.90156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.4c6df951bb3d17e8098243d177531cda.svg";
export { ForwardRef as ReactComponent };